import Button from "@app/sharedComponents/Button/Button";
import {  ThemedText, ThemedView } from "@app/theme";

const FlexibleInfo = ({monthlyEMIRate,closeBottomSheet})=>{
    return(
        <ThemedView p="lg">
            <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center"  mb="lg">
            <ThemedText variant="h5s" color="text-primary">Principal repayment schedule</ThemedText>

            </ThemedView>
            <ThemedView 
                mb="lg"
                flexDirection="row"
                flexWrap='wrap' 
                p="lg" 
                mt="sm" 
                backgroundColor="bg-fill-info"
                borderRadius="sm"
            >
                <ThemedText variant="b3r" color='text-secondary'>
                You can repay principal outstanding as per your convenience while you pay a minimum monthly interest per month at an interest rate of <ThemedText variant="b3b" color='text-primary'>
                {monthlyEMIRate}% per month 
                </ThemedText>
                </ThemedText> 
               
            </ThemedView>
            <Button label="Ok, got it!" handlePress={closeBottomSheet} type="SOLID"/>

        </ThemedView>
    )
}

export default FlexibleInfo;   